export default {
    excess: 'Franchigia danni',
    security: 'Deposito cauzionale',
    fuel_policy: 'Politica del carburante',
    like_for_like: 'Like for Like',
    full_to_full: 'Full to Full',
    mileage: 'Miglia: {mileage} miglia per noleggio',
    unlimited_mileage: 'Miglia illimitati',
    non_refundable: 'Non rimborsabile',
    free_cancellation_until: 'Cancellazione gratuita fino al {date}',
    cancellation_with_terms: 'Cancellazione {0} in linea con ',
    t_c_text: 'Termini e Condizioni',
    two_free_extras: 'Due extra gratuiti al ritiro',
    glass_tyres_covered: 'Copertura vetri e gomme'
}
